import { render } from "./Edit.vue?vue&type=template&id=378d587e&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "../../assets/css/client.css?vue&type=style&index=0&id=378d587e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378d587e"]])

export default __exports__